module.exports = __webpack_public_path__ + "static/img/jigou-tianjin-bottom.d80379a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-tianjin-bottom.png
// module id = zeTh
// module chunks = 2